<template>
<div class="layout-app" ref='myBox'>
	<!-- main -->
<el-dialog :title="diglogTile" :visible.sync="exaDialogVisible" width="52%" :before-close="handleClose" :destroy-on-close='true' :modal="false"
:close-on-click-modal="false">
		<!-- 提交审核过单 -->
	<div class="addAcc">
			<!-- tabs -->
			<div class="tabs">
				<div class="tabsMain">
					<!-- 表单 -->
					<el-form ref="form" :model="addForm" label-width="128px" size="mini" :disabled="true" >
						<el-row :gutter="8">
							<el-col :xs="val.xs" :sm="val.xs" :md="val.md" :lg="val.lg" :xl="val.xl" type="flex" v-for="(val,i) in formType" :key="i">
								<!-- input -->
								<el-form-item v-if="val.type == 'input'" :label="val.label" :prop="val.modelValue">
									<el-input :suffix-icon='val.prefix' v-model="$data.addForm[val.modelValue]" :placeholder="val.placeholder"></el-input>
								</el-form-item>
								<!-- textarea -->
								<el-form-item v-if="val.type == 'textarea'" :label="val.label" :prop="val.modelValue">
									<el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="$data.addForm[val.modelValue]"></el-input>
								</el-form-item>
								<!-- select -->
								<el-form-item v-if="val.type == 'select'" :label="val.label" :prop="val.modelValue">
									<el-select v-model="$data.addForm[val.modelValue]" filterable placeholder="请选择" :disabled="val.disabled">
										<el-option v-for="item in $data[val.op]" :key="item.id" :label="item.label" :value="item.id"> 
										<span style="color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
									</el-select>
								</el-form-item>
								<!-- date -->
								<el-form-item v-if="val.type == 'date'" :label="val.label" :prop="val.modelValue">
									<el-date-picker  :disabled="val.disabled ? true : false"
									type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="$data.addForm[val.modelValue]">
									</el-date-picker>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
					<!-- table -->
					<div class="table">
						<el-table :data="tableData" border @row-dblclick="handledbRow" :style="{ width: tableWidth + 'px' }">
							<el-table-column prop="drugId" label="药品序号" align='center'></el-table-column>
							<el-table-column prop="invyId" label="库存序号" align='center'></el-table-column>
							<el-table-column prop="docId" label="调拨序号" align='center'></el-table-column>
							<el-table-column prop="name" label="药品名称" align='center'></el-table-column>
							<el-table-column prop="purcType" label="库存类型">
								<template slot-scope="{ row }">
									<!-- 根据state显示不同的图标 -->
									<div class="stateValue" style="border-radius: 4px;text-align: center;">
										<span>{{ purcTypeMap[row.purcType] || '未知状态' }}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="apllyAmt" label="调拨数量" align='center'>
								<template slot-scope="{ row }">
									<!-- 根据state显示不同的图标 -->
									<div class="stateValue" style="border-radius: 4px;text-align: center;">
										<span>{{ row.apllyAmt }}</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="unt" label="入库单位" align='center'></el-table-column>
							<el-table-column prop="purcPric" label="成本单价" align='center'></el-table-column>
							<el-table-column prop="purcAmt" label="成本金额" align='center'></el-table-column>
							<el-table-column prop="salePric" label="零售单价" align='center'></el-table-column>
							<el-table-column prop="saleAmt" label="零售金额" align='center'></el-table-column>
							
							<el-table-column prop="prodentpName" label="生产厂家" align='center' width="228"></el-table-column>
							<el-table-column prop="manuLotnum" label="生产批号" align='center' width="128"></el-table-column>
							
							<!-- <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column> -->
							<!-- fixed -->
							<el-table-column fixed="left" label="行号" type="index" width="68" align="center"></el-table-column>
						</el-table>
						<div class="total">
						  <span>成本合计金额：</span>
						  <el-input :value="formattedCbValue" style="width: 128px;" size="mini" :disabled='totaldisabled'></el-input>
						  <span style="margin-left: 12px;">零售合计金额：</span>
						  <el-input :value="formattedLsValue" style="width: 128px;" size="mini" :disabled='totaldisabled'></el-input>
						</div>
					</div>
				</div>
			</div>
			<!-- 查看模式：只有关闭按钮 -->
			<div v-if="currentOperation === 'detail'" slot="footer" class="dialog-footer">
			    <el-button size="mini" @click="exaDialogVisible = false">关闭</el-button>
			</div>
			<!-- 提交按钮 -->
			<div v-if="currentOperation === 'submit'" slot="footer" class="dialog-footer">
			  <el-button size="mini" type="primary" @click="Submit">确定提交</el-button>
			  <el-button size="mini" @click="exaDialogVisible = false">取消</el-button>
			</div>
			
			<!-- 审核按钮 -->
			<div v-else-if="currentOperation === 'audit'" slot="footer" class="dialog-footer">
			  <el-button size="mini" type="danger" @click="refuseExamine">拒绝审核</el-button>
			  <el-button size="mini" type="primary" @click="exaSubmit">确定审核</el-button>
			  <el-button size="mini" @click="exaDialogVisible = false">取消</el-button>
			</div>
			
			<!-- 过单按钮 -->
			<div v-else-if="currentOperation === 'pass'" slot="footer" class="dialog-footer">
			  <el-button size="mini" type="danger" @click="refusePassOrder">拒绝过单</el-button>
			  <el-button size="mini" type="primary" @click="passOrderSubmit">确定过单</el-button>
			  <el-button size="mini" @click="exaDialogVisible = false">取消</el-button>
			</div>
	</div>
</el-dialog>
</div>
</template>

<script>
// self
import AccType from './addAllocateType.js'
import addForm from './addForm.js' //Form表单
// prop

// ext

// 接口
import { changedpurcallocate,getdpurcallocate,findAttribute } from "@/api/systemCatalogue/Western.js";
export default {
	props: ['parentMethod'],
	components:{
		
	},
	props: {
	    visible: {
	      type: Boolean,
	      default: false
	    },
	    // 新增：接收操作类型
	    operationType: {
	      type: String,
	      default: ''
	    },
	    // 新增：接收调拨单ID
	    transferId: {
	      type: [String, Number],
	      default: null
	    }
	  },
	  // 计算属性
	  computed: {
	    formattedCbValue() {
	      return this.formatCurrency(this.cbValue);
	    },
	    formattedLsValue() {
	      return this.formatCurrency(this.lsValue);
	    },
		// 新增：判断是否为查看模式
		isViewMode() {
		  return this.currentOperation === 'detail';
		}
	  },
	data(){
		return{
			//str
			// 将currentOperation移到data中，通过props控制
			  currentOperation: '',
			  currentTransferId: null,
			diglogTile:'', // 动态页面的动态标题
			tableWidth:'', //右侧表格动态宽度
			totalAmt:'', //合计金额
			value:'',
			deptCode:'',
			cbValue:'',
			lsValue:'',
			getLunarDay: '',
			areaCode:'',
			areaPName:'',
			idx:'',
			//num
			// currentTransferId: null, // 新增：存储当前调拨单ID
			//ble
			disabled:true,
			totaldisabled:true,
			exaDialogVisible:false,
			dialogFormVisible:false,
			//arr
			formType:[],
			tableData:[],
			selectOption:[{id:1,label:'西药库'},{id:2,label:'中药库'},{id:3,label:'西药房'},{id:4,label:'中药房'}],
			optionks:[{id:1,label:'西药库'},{id:2,label:'中药库'},{id:3,label:'西药房'},{id:4,label:'中药房'}],
			ghdwOption:[],
			nameOption:[],
			tableRows:[
				{ name:"药品名称", prop:"name" },{ name:"药品序号", prop:"drugId",  },
				{ name:"库存序号", prop:"invyId" },{ name:"调拨序号", prop:"docId"  },
				{ name:"调拨数量", prop:"apllyAmt", nz:"nz" },{ name:"成本单价", prop:"purcPric", type:"" },
				{ name:"成本金额", prop:"purcAmt", type:"" },{ name:"零售单价", prop:"salePric", type:"" },
				{ name:"零售金额", prop:"saleAmt", type:"" },{ name:'生产厂家',prop:'prodentpName'},
				{ name:'生产批号',prop:'manuLotnum'}
			],
			purcTypeMap: {
				1: '最小单位',
				2: '包装单位',
			},
			//obj
			addForm:{}, // form表单 * saleAmt
			options:[],
			ksOption:[],
			ssrOption:[],
			gysOption:[],
		}
	},
	
	watch: {
	    // 监听visible变化
	    visible: {
	      immediate: true,
	      handler(newVal) {
	        if (newVal) {
	          // 对话框打开时，使用props中的数据
	          this.currentOperation = this.operationType;
	          this.currentTransferId = this.transferId;
	          
	          if (this.currentTransferId) {
	            this.loadTransferData();
	          }
	        }
	      }
	    },
	    // 监听props变化
	    operationType: {
	      immediate: true,
	      handler(newVal) {
	        this.currentOperation = newVal;
	      }
	    },
	    transferId: {
	      immediate: true,
	      handler(newVal) {
	        this.currentTransferId = newVal;
	        if (newVal && this.visible) {
	          this.loadTransferData();
	        }
	      }
	    }
	  },
	mounted() {
		// 获取接口参数
		this.getAddForm();
		// 定义数据来源
		this.formType = AccType.map(function(val) { return val })
		// 获取制单人 => 当前登录用户
		// this.addForm.createId = JSON.parse(localStorage.getItem('userInfo')).userId;
	},
	methods:{
		async loadTransferData() {
		      if (!this.currentTransferId) return;
		      
		      try {
		        let res = await getdpurcallocate({ id: this.currentTransferId });
		        
		        // 数据处理
		        for (let key in res.data) {
		          if (key === 'details') {
		            res.data['detailsVOS'] = res.data[key];
		            delete res.data[key];
		            break;
		          }
		        }
		        
		        this.addForm = res.data;
		        this.addForm.busDate = '';
		        this.cbValue = res.data.costAmt;
		        this.lsValue = res.data.detailsVOS.reduce((total, item) => {
		          return total + parseFloat(item.saleAmt);
		        }, 0);
		        
		        this.tableData = res.data.detailsVOS;
		        
		      } catch (error) {
		        console.error('加载调拨单数据失败:', error);
		        this.$message.error('加载数据失败');
		      }
		    },
		    
			formatCurrency(value) {
			    if (value === null || value === undefined || value === '') return '¥0.00';
			    
			    const num = Number(value);
			    if (isNaN(num)) return '¥0.00';
			    
			    return '¥' + num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
			  },
		    // 新增：设置对话框标题
		    setDialogTitle() {
		          const titleMap = {
		            'detail': '查看调拨单',
		            'submit': '提交调拨单',
		            'audit': '审核调拨单', 
		            'pass': '过单调拨单'
		          };
		          this.diglogTile = titleMap[this.currentOperation] || '调拨单操作';
		        },
		// 打开model 获取采购计划数据
		// 修改子组件的 openModel 方法
		async openModel(parm) {
		  try {
		    console.log('接收到的参数:', parm);
		    
		    // 重置状态
		    this.currentTransferId = parm.id;
		    this.currentOperation = parm.name ? parm.name.toLowerCase() : 'detail';
		    this.exaDialogVisible = true;
		    
		    this.setDialogTitle();
		    
		    // 根据操作类型设置表单状态
		    this.disabled = this.currentOperation === 'detail';
		    this.totaldisabled = this.currentOperation === 'detail';
		    
		    // 加载数据
		    if (this.currentTransferId) {
		      await this.loadTransferData();
		    }
		    
		  } catch (error) {
		    console.error('打开模态框失败:', error);
		    this.$message.error('加载数据失败');
		  }
		},
		
		deleteRow(index, rows) {
		  rows.splice(index, 1);
		},
		// 科室档案
		async getKs(){
			let rs = await findAttribute()
			this.ksOption = rs.data.map(obj => {
			  // 将 name 替换为 label，并保留其他字段
			  return { label: obj.deptName , ...obj };
			});
			console.log(this.ksOption,'joiiasdoop');
		},
		testDate(val,i){
			this.idx = val.id
		},
		handleClose(done) {
			done();
		},
		
		// 确定提交
		async Submit() {
		      if (!this.currentTransferId) {
		        this.$message.error('未找到调拨单ID');
		        return;
		      }
		      
		  let result = await changedpurcallocate({
			id: this.currentTransferId,
			state: 2 // 提交状态
		  });
		  this.handleOperationResult(result, 'submit');
		},
		
		//确定审核
		async exaSubmit() {
		      if (!this.currentTransferId) {
		        this.$message.error('未找到调拨单ID');
		        return;
		      }
		      
		      let result = await changedpurcallocate({
		        id: this.currentTransferId,
		        state: 4 // 审核状态
		      });
		      this.handleOperationResult(result, 'audit');
		    },

		// 拒绝审核操作也添加通知
		refuseExamine() {
		  if (!this.currentTransferId) {
		    this.$message.error('未找到调拨单ID');
		    return;
		  }
		  
		  this.$confirm('此操作将回退该条数据状态, 是否继续?', '提示', {
		    confirmButtonText: '确定',
		    cancelButtonText: '取消',
		    type: 'warning'
		  }).then(async() => {
		    let result = await changedpurcallocate({
		      id: this.currentTransferId,
		      state: 0 // 回退到草稿
		    });
		    this.handleOperationResult(result, 'reject-audit');
		  }).catch(() => {
		    this.$message({ type: 'info', message: '操作已取消'});          
		  });
		},

		// 统一处理操作结果
		// 统一处理操作结果 - 修复版本
		handleOperationResult(result, operationType) {
		  if (result.code === 200) {
		    this.$message({ 
		      type: 'success', 
		      message: result.message || '操作成功' 
		    });
		    this.exaDialogVisible = false;
		    this.currentTransferId = null;
		    
		    // 修复：确保正确通知父组件
		    this.$emit('operation-success', {
		      code: 200,
		      operation: operationType,
		      data: result.data,
		      message: result.message || '操作成功',
		      timestamp: new Date().getTime()
		    });
		    
		    // 关闭对话框
		    this.$emit('update:visible', false);
		  } else {
		    this.$message.error(result.message || '操作失败');
		    
		    // 即使失败也要通知父组件
		    this.$emit('operation-success', {
		      code: result.code,
		      operation: operationType,
		      data: null,
		      message: result.message || '操作失败',
		      timestamp: new Date().getTime()
		    });
		  }
		},
				
		//确定过单
		async passOrderSubmit() {
		      if (!this.currentTransferId) {
		        this.$message.error('未找到调拨单ID');
		        return;
		      }
		      
		      let result = await changedpurcallocate({
		        id: this.currentTransferId,
		        state: 5 // 过单状态
		      });
		      this.handleOperationResult(result, 'pass');
		    },
		
		// 拒绝过单
		refusePassOrder() {
		  if (!this.currentTransferId) {
		    this.$message.error('未找到调拨单ID');
		    return;
		  }
		  
		  this.$confirm('此操作将回退该条数据状态, 是否继续?', '提示', {
		    confirmButtonText: '确定',
		    cancelButtonText: '取消',
		    type: 'warning'
		  }).then(async() => {
		    let result = await changedpurcallocate({
		      id: this.currentTransferId,
		      state: 2 // 回退到已提交
		    });
		    this.handleOperationResult(result, 'reject-pass');
		  }).catch(() => {
		    this.$message({ type: 'info', message: '操作已取消'});          
		  });
		},
		
		// 草稿保存
		async draftSubmit(){
			 this.addForm.list.push(this.lists)
			 this.addForm.totalAmt = this.cbValue
			 this.addForm.state = 0
			 console.log(this.addForm);
			 let result = await addPurchasingPlan(this.addForm)
			 if (result.code === 200) {
			 	this.loadData(); // 更新数据驱动 => 父组件 shopPlan
			 	this.$message({ type: 'success', message: result.message});
			 	this.exaDialogVisible = false;
			 } else {
			 	this.$message.error(result.message)
			 }
		},
		//sons
		// db events
		handledbRow(row, column, event){
			if(row){ this.form = row; this.watchDialogVisible = true } else { console.log('fail'); }
			// console.log(this.form);
			this.formdisabled = true
			// this.form.textSpell = this.makePy(this.form.label).toLocaleUpperCase()
			// console.log(this.form.textSpell);
		},
		// col 里面包含了表头字段和名称，list 是表格数据
		columnWidth(col, list) {
		  let prop = col.prop,lab = col.lab;
		  let width = 40; // 设定一个最小值
		  let maxlenStr = ""; // 最长字符串
		  for (let info of list) {
			if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
		  }
		  width = Math.max(width, len(lab), len(maxlenStr));
		  // 表格自带的内边距(20px) 自调
		  return width + 24; // 这里加了 12px
		  function len(str) {
			// 实际分配长度可根据需要自行调整
			let length = 12;
			for (const char of str + "") {
			  // 英文小写字符 8px
			  if ("a" <= char && char <= "z") length += 8;
			  // 英文大写字符 8px
			  else if ("A" <= char && char <= "Z") length += 8;
			  // 中文字符 28px
			  else if (char >= "\u4e00" && char <= "\u9fa5") length += 28;
			  // 其他 8px
			  else length += 12;
			}
			return length;
		  }
		},
		// 挂载或销毁前后重新赋值后端参数
		getAddForm(){
			// 左侧提交表单
			this.addForm = addForm.map(v => {return v })[0]; // Form
			this.addMainForm = this.addForm.detailsVOS[0]
			this.getKs();
			// 定义数据来源
			this.formType = AccType.map(function(val) { return val })
			// 解构赋值排除 list 属性 => 弃用
			// this.addHeadrForm = addForm.map(item => { let { list, ...newItem } = item; return newItem })[0];
		},
	},
	
}
</script>

<style lang="less" scoped>
	/deep/ .el-dialog__header{
	    padding: 4px;
	    line-height: 28px;
	    background-color: #007bb0;
	}
	/deep/ .el-dialog__title{
	    color: #fff;
	    font-size: 12px;
	}
	/deep/ .el-dialog__headerbtn{
	    top: 10px;
	}
	/deep/ .el-dialog__body{
	    padding: 8px;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close{
	    color: #fff;
	}
	/* 在第一个代码文件的style部分添加 */
	.transfer-operation-loading {
	  position: absolute;
	  top: 50%;
	  left: 50%;
	  transform: translate(-50%, -50%);
	  z-index: 1000;
	}
	
	/* 模态框过渡动画 */
	.dialog-transition-enter-active {
	  transition: all 0.3s ease;
	}
	.dialog-transition-leave-active {
	  transition: all 0.3s ease;
	}
	.dialog-transition-enter-from {
	  opacity: 0;
	  transform: scale(0.9);
	}
	.dialog-transition-leave-to {
	  opacity: 0;
	  transform: scale(0.9);
	}
.layout-app{
    width: 100%;
    height: 100%;
    display: flex;
	background-color: f8f8f8;
    .addAcc{
		
		/deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
			margin-bottom: 8px;
		}
		/deep/ .el-dialog__title{
			color: #fff;
		}
		/deep/ .el-dialog__headerbtn .el-dialog__close{
			color: #fff;
		}
		/deep/ .el-dialog__headerbtn .el-dialog__close:hover{
			background-color: brown;
		}
		/deep/ .el-dialog__body{
			padding: 0;
		}
		/deep/ .el-divider--horizontal{
			margin: 0;
		}
		/deep/ .el-form-item__label{
			display: flex;
			justify-content: start;
			font-size: 12px;
		}
		// self
		// 选项卡
		.tabs{

			.tabsMain{
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 8px;
				/deep/ .el-select> .el-input{
					// width: 118px;
				}
				/deep/ .el-input--mini .el-input__inner{
					height: 26px;
				}
				/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
					width: 100%;
				}
				border: 1px solid #EBEEF5;
				padding: 12px;
				/deep/ .el-form-item__label{
					display: flex;
					justify-content: start;
					font-size: 12px;
					width: 100%;
				}
				.a{
					flex: 1;
					display: flex;
					align-items: center;
				}
				.table{
					width: 100%;
					margin-top: 12px;
					/deep/ .el-table th{
						color: #2d2d2d;
						font-weight: bold;
						font-size: 12px;
						height: 18px;
						line-height: 18px;
					}
					/deep/ .el-table th.el-table__cell>.cell{
						// border-right: 2px solid #ececec;
						height: 18px;
						line-height: 18px;
						display: flex;
						align-items: center;
					}
					/deep/ .el-table td.el-table__cell div{
						font-size: 12px;
						height: 18px;
						line-height: 18px;
					}
					// padding: 16px;
					/* 自定义高亮颜色 */
					::v-deep .el-table__body tr.current-row > td {
					  background-color: #55aaff !important;
					  color: #f9f9f9; /* 可选：修改文字颜色 */
					}
				}
				.total{
					display: flex;
					height: 48px;
					align-items: center;
					span{
						font-size: 12px;
					}
				}
			}	
		}
		.dialog-footer{
			display: flex;
			justify-content: right;
		}
	}
}
</style>